import React, { useState } from 'react';
import axios from 'axios';
import './ClientVerification.css';
import logo from '../../icons/logo.png'; // Assuming logo path based on Login.js

const ClientVerification = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const handleVerify = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        try {
            // Adjust base URL if needed, assuming relative path or proxy setup in package.json
            // Or use the hardcoded one from Login.js logic if available, but relative is safer if proxy exists.
            // Looking at Login.js, it uses UserServices.
            // I'll use axios directly for this standalone module to keep it simple, pointing to the standard API URL.
            // Ideally should use process.env.REACT_APP_API_URL or similar if available.
            // For now, I will assume the same base URL structure as the rest of the app usually defaults to via proxy or explicit URL.
            // Login.js does not show the base URL explicitly, it uses UserServices.
            // I'll try to guess the Base URL is standard localhost or whatever UserServices uses.
            // Let's assume standard localhost:8000/api/v1 for now given the backend path.

            const API_URL = process.env.REACT_APP_API_Link;
            const response = await axios.post(`${API_URL}/client-verification`, { email });

            if (response.data.status) {
                setStatus({ type: 'success', message: response.data.message });
            }
        } catch (error) {
            if (error.response) {
                setStatus({
                    type: 'error',
                    message: error.response.data.message || 'Verification failed.'
                });
            } else {
                setStatus({ type: 'error', message: 'Network error. Please try again.' });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="verification-container">
            <div className="verification-card">
                <div className="logo-section">
                    <img src={logo} alt="Vostro World" />
                </div>

                <h1 className="title">Client Verification</h1>

                <form onSubmit={handleVerify}>
                    <div className="input-group">
                        <label>Enter your email for verification</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="example@email.com"
                        />
                    </div>

                    <button type="submit" className="verify-btn" disabled={loading}>
                        {loading ? 'Verifying...' : 'Verify'}
                    </button>
                </form>

                {status.message && (
                    <div className={`message ${status.type}`}>
                        {status.message}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClientVerification;
